import React from 'react';

import nfeInfo from 'services/NFeInfo';
import {
  CardContainer,
  CardTitle,
  InfoBox,
  InfoIcon,
  FieldsGrid,
  FieldGroup,
} from './styles';
import Select from '~/components/Form/SelectInput';
import TaxOptionCard from './TaxOptionCard';
import { IconInfo } from 'takeat-design-system-ui-kit';

function IbsCbsComponent({
  ibsCbsSituacao,
  setIbsCbsSituacao,
  ibsCbsClassificacao,
  setIbsCbsClassificacao,
  setIbsCbsClassificacaoOptions,
  ibsCbsClassificacaoOptions,
  showOptions = true
}) {
  function updateIbsCbsClassificacaoOptions(situacao) {
    setIbsCbsClassificacaoOptions(nfeInfo.ibs_cbs_situacao_tributaria.find(x => x.value === situacao).classificacoes);
  }

  return (
    <CardContainer>
      <CardTitle>
        Configuração da Reforma Tributária (IBS e CBS)
      </CardTitle>

      <InfoBox>
        <InfoIcon><IconInfo /></InfoIcon>
        <div>
          Se o seu restaurante se enquadra na <strong>reforma tributária</strong> e precisa configurar os valores do IBS e CBS para emissão fiscal em 2026, já é possível ajustar essas informações nos itens.
          Caso tenha dúvidas sobre a necessidade de preenchê-las ou sobre os valores corretos, recomendamos entrar em contato com seu contador.
        </div>
      </InfoBox>

      {showOptions &&
        <>
          <TaxOptionCard
            setIbsCbsSituacao={setIbsCbsSituacao}
            setIbsCbsClassificacao={setIbsCbsClassificacao}
            ibsCbsSituacao={ibsCbsSituacao}
            ibsCbsClassificacao={ibsCbsClassificacao}
            updateIbsCbsClassificacaoOptions={updateIbsCbsClassificacaoOptions}
          />
          <FieldsGrid style={{ padding: 5, marginBottom: 3 }}>
            <FieldGroup>
              <Select
                name="ibs_cbs_situacao_tributaria"
                options={nfeInfo.ibs_cbs_situacao_tributaria}
                label="IBS e CBS - Situação Tributária"
                value={nfeInfo.ibs_cbs_situacao_tributaria.filter(sit => sit.value === ibsCbsSituacao)}
                onChange={(e) => {
                  setIbsCbsSituacao(e.value);
                  setIbsCbsClassificacao(null);
                  updateIbsCbsClassificacaoOptions(e.value);
                }}
                style={{ fontSize: 14 }}
              />
            </FieldGroup>

            <FieldGroup>
              <Select
                name="ibs_cbs_classificacao_tributaria"
                options={ibsCbsClassificacaoOptions}
                label="IBS e CBS - Classificação Tributária"
                value={ibsCbsClassificacaoOptions.filter(sit => sit.value === ibsCbsClassificacao)}
                onChange={(e) => {
                  setIbsCbsClassificacao(e.value);
                }}
              />
            </FieldGroup>
          </FieldsGrid>
        </>
      }
    </CardContainer>);
}

export default IbsCbsComponent;